import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { DestaquesSend } from '../_model/Destaques';
import { Media } from '../_model/media';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DestaquesService {

constructor(private http: HttpClient) { }

baseUrl: string = "https://"+environment.apiUrl+"/api/destaques/";

list() {
  return this.http.post(this.baseUrl+"list", null)
    .pipe(
      map((data: any) => {
        return data.result;
      })
    );
}
send(model: DestaquesSend) {
  return this.http.post(this.baseUrl+"input", model).pipe();
}
getMediaRaw(id: number) {
  return this.http.post(this.baseUrl+"media/"+id, null)
    .pipe(
      map((data: any) => {
        var result: Media[] = [];
        data.result.forEach(el => {
          result.push(new Media(el));
        });
        return result;
      })
    );
}
delete(id: number, userId: string) {
  return this.http.post(this.baseUrl+"delete/"+id, {id: userId}).pipe();
}
getDestaque() {
  return this.http.post(this.baseUrl, null).pipe(
    map((data:any) => {
      return data.result;
    })
  );
}

}
